/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import '../style/whoami.css'
import who from '../images/umang-new-bg.jpg'

const WhoAmI = () => {
    return (
        <>
            <div className='container' style={{marginTop:'100px', marginBottom:'70px'}}>
                <div className='row' id='roBl'>
                    <div className='col' id='colUni1'>
                        <h2 style={{ color: "#E1362C" }}>WHO AM I?</h2>
                        <h2 style={{ color: 'rgb(13 92 126)' }}>MEET UMANG RATANI</h2>
                        <h5 style={{ marginTop: '20px' }}>As a Start-Up, Business Success Coach, and TEDx Speaker, I've had the privilege of impacting lives and businesses worldwide. Over the past decade, I’ve had the privilege of coaching over 20,000 individuals and assisting more than 200 business owners in boosting their revenue. My expertise spans across 30 diverse industries, ensuring a broad and impactful approach to growth and success.</h5>
                        <h5 style={{ marginTop: '10px' }}>Whether you need Virtual CEO and CFO services, or personalized business growth strategies, I’m here to help. Let's connect and turn your business aspirations into reality.</h5>
                        <div className='btnTalk' >
                            <a href="/MyStory" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "25px", fontWeight: '500' }} className="btn btn-primary btn-lg">Know My Story
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className='col' id='uni1' style={{ textAlign: 'center' }}>

                        <img
                            id="pictureframe"
                            src={who}
                            alt='umang'
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhoAmI
